/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

export default class CircularBuffer {
  /**
   * @param {number} size Velikost bufferu.
   */
  constructor(size) {
    this.size = size;
    // Preallocate the buffer
    this.buffer = new Array(size);
    // Points to the next position to write
    this.head = 0;
    // Points to the oldest position in the buffer
    this.tail = 0;
    // Keeps track of the current number of elements
    this.length = 0;
  }

  /**
   * Přidá hodnotu do bufferu.
   * @param {number} value Hodnota, která má být přidána do buffru.
   */
  add(value) {
    this.buffer[this.head] = value;
    this.head = (this.head + 1) % this.size;

    // If the buffer is full, we overwrite the oldest value
    if (this.length < this.size) {
      this.length += 1;
    } else {
      this.tail = (this.tail + 1) % this.size;
    }
  }

  /**
   * Získá nejstarší hodnotu, pokud je buffer prázdný je vráceno null.
   * @returns {number | null}
   */
  get() {
    if (this.length === 0) {
      // Buffer is empty
      return null;
    }
    const value = this.buffer[this.tail];
    this.tail = (this.tail + 1) % this.size;
    this.length -= 1;
    return value;
  }

  /**
   * Získá pole obsah bufferu.
   * @returns {number[]}
   */
  getAll() {
    const result = [];
    for (let i = 0; i < this.length; i += 1) {
      const index = (this.tail + i) % this.size;
      result.push(this.buffer[index]);
    }
    return result;
  }

  /**
   * @returns {boolean} True, pokud je buffer plný.
   */
  isFull() {
    return this.length === this.size;
  }

  /**
   * @returns {boolean} True, pokud je buffer prázdný.
   */
  isEmpty() {
    return this.length === 0;
  }
}
